/** Превью нового сообщения у кнопки «Чат» уходит само через столько; новое заменяет прежнее. */
export const SUPPORT_CHAT_PREVIEW_TIMEOUT = 6000;
/** «Специалист включил микрофон» держится дольше: под ним кнопка. */
export const SUPPORT_MIC_TOAST_TIMEOUT = 12000;
/** Подсказка про чат и микрофон — один раз на пользователя (в этом браузере). */
export const SUPPORT_SHARE_HINT_KEY = 'srm.screenShare.voiceHintSeen';

/** Под именем специалиста, включившего микрофон. */
export const SUPPORT_MIC_TOAST_TEXT = 'включил микрофон — включите свой, чтобы поговорить';

/** Карточка микрофона диктору: что делать, а не только что случилось. */
export const supportMicAnnouncement = (name: string) =>
    `${name} включил микрофон. Чтобы ответить голосом, нажмите «Микрофон» в полосе показа`;
